import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveSessions, KeyValues3, KeyValueSet, LocalService, SessionConfigType, Status, TriggeredEvent } from '../../../service/local.service';
import { SessionConfigComponent } from '../session-config/session-config.component';

@Component({
  selector: 'app-seats-billing',
  templateUrl: './seats-billing.component.html',
  styleUrls: ['./seats-billing.component.scss']
})
export class SeatsBillingComponent implements OnInit {
  billingId = ''; businessId = ''; tokenNumber = '';
  lstSectionConfigKeys: string[] = ["reservation", "table"]; maxBodyHeight = 0; isRedAlert = true; message = '';
  activeSessions: ActiveSessions; isAllowToEdit = false;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private billingManagementService: BillingManagementService, private cdr: ChangeDetectorRef, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.billingManagementService.getSessionsByBillingId(this.billingId).subscribe(result => {
      this.activeSessions = result;
    });
  }

  onAction(index, key = '') {
    this.message = '';
    switch (index) {
      case 3: {
        this.billingManagementService.getSeatsBySessionId(key, true).subscribe(result => {
          let item = this.activeSessions.seats.find(x => x.sessionKey == key);
          if (item) {
            item.availablity = result.availablity;
            item.groups = result.groups
          } else {
            this.activeSessions.seats.push(result);
          }
        });
      } break;
      case 8: {
        this.billingManagementService.getBillsBySessionId(key).subscribe(result => {
          let item = this.activeSessions.bills.find(x => x.key == key);
          if (item) {
            item.value = result.value;
          } else {
            this.activeSessions.bills.push(result);
          }
        });
      } break;
    }
  }

  isSeatsLoaded(sessionKey): boolean {
    let item = this.activeSessions.seats.find(x => x.sessionKey == sessionKey);
    return item ? true : false;
  }

  isBillsLoaded(sessionKey): boolean {
    let item = this.activeSessions.bills.find(x => x.key == sessionKey);
    return item ? true : false;
  }

  onGetSeats(strSessionId): KeyValues3[] {
    if (this.activeSessions.seats) {
      let item = this.activeSessions.seats.find(x => x.sessionKey == strSessionId);
      return item ? item.groups : [];
    } else {
      return [];
    }
  }

  onGetBills(strSessionId): KeyValueSet[] {
    if (this.activeSessions.seats) {
      let item = this.activeSessions.bills.find(x => x.key == strSessionId);
      return item ? item.value : [];
    } else {
      return [];
    }
  }

  onDetachBill(sessionKey, billKey) {
    this.billingManagementService.detachBill(billKey, [sessionKey], false, this.businessId).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.activeSessions.sessions = this.activeSessions.sessions.filter(x => x.key != sessionKey);
      }
    });
  }

  onGetSeatArrangementBySessionId(strSessionId, key): KeyValueSet[] {
    return this.activeSessions.seats.find(x => x.sessionKey == strSessionId).availablity.find(x => x.key == key).value;
  }

  onCheked(index) {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(SessionConfigComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.sessionConfigType = SessionConfigType.AttachBill;
        modalRef.componentInstance.selectedToken = this.tokenNumber;
        modalRef.componentInstance.isForceAttachBill = true;
        modalRef.componentInstance.ignoreSessionIds = this.activeSessions.sessions.map(x => x.key);
        modalRef.result.then((result) => {
          this.onLoad();
        }, (error) => {
          this.onLoad();
        });
      } break;
      case 2: {
        const modalRef = this.modalService.open(SessionConfigComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.sessionConfigType = SessionConfigType.Add;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.billingManagementService.attachBill(this.businessId, this.tokenNumber, [result.data], false).subscribe(result => {
              this.localService.showInformationByStatus(result.status);
              if (result.status == Status.Success) {
                this.onLoad();
              } else if (result.status == Status.Invalid) {
                this.message = this.localService.languageContent.reservation.invalid_receipt_num;
              }
            });
          }
        });
      } break;
    }
  }
}
